export interface AppState {
  ready: boolean;
  searchType: string;
  appState: APP_STATE;
  mapRedrawTriggerState?: MAP_TRIGGER;
}

export enum APP_STATE {
  SEARCH = 'search',
  RESULTS_FOUND = 'results-found',
  RESULTS_NOT_FOUND = 'results-not-found',
  ERROR = 'error',
  NO_MAP_RESULTS = 'no-map-results',
  NO_ZIP_FOUND = 'no-zip-found',
  OUT_OF_COUNTRY = 'out-of-country'
}

export enum MAP_TRIGGER {
  ON_DRAG = 'drag',
  ON_PAGINATE = 'paginate',
  ON_SEARCH = 'search',
  ON_ERROR = 'error'
}

export const initialAppState: AppState = {
  ready: true,
  searchType: 'location',
  appState: APP_STATE.SEARCH
};
